import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import {
  EntityOrderedRequestParameters,
  EntityPagedRequestParameters,
} from "@bndes/bndes-ux4/bndes-angular-utils";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { DetalheLeilao } from "src/app/model/leilao.model";
import Utils from "src/app/shared/fgi-utils";

@Component({
  selector: "app-consulta-status-leilao-listagem",
  templateUrl: "./consulta-status-leilao-listagem.component.html",
  styleUrls: ["./consulta-status-leilao-listagem.component.scss"],
  standalone: false
})
export class ConsultaStatusLeilaoListagemComponent implements OnInit {
  @Input() set setDetalhesLeilao(detalhesLeilao: DetalheLeilao[]) {
    if (detalhesLeilao) this.detalhesLeilao = detalhesLeilao;
  }

  @Input() public atributosPaginacao: EntityPagedRequestParameters;
  @Input() public ehAgenteFinanceiro: boolean;
  @Input() public mostrarDatasValores: boolean;

  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> =
    new EventEmitter<EntityPagedRequestParameters>();

  public atributosOrdenacao: EntityOrderedRequestParameters;

  public podeEditar: boolean;

  private agentesFinanceiros: AgenteFinanceiro[] = [];
  detalhesLeilao: DetalheLeilao[] = [];

  constructor(private readonly activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.agentesFinanceiros = this.activatedRoute.snapshot.data["agentes"];

    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  public nomeAgente(cnpj: string) {
    const agentes = this.agentesFinanceiros.filter(
      (item) => item.cnpj === cnpj
    );
    return agentes.length > 0
      ? agentes[0].nome
      : `agente cnpj ${cnpj} desconhecido.`;
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    let funcao = undefined;
    if (ord.atributo == "id") {
      funcao = parseFloat;
    }

    this.detalhesLeilao = this.detalhesLeilao.sort((a, b) => {
      if (ord.sentido == "asc") {
        return Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      } else {
        return -1 * Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      }
    });
  }

}
